import { DashboardRoutes } from "@/router";
import { Outlet, useLocation } from "react-router-dom";
import NavigationLayout from "@/components/NavigationLayout";
import { DetectMobileView } from "@/router/DetectMobileView";
import { dashboardRoutesArray } from "@/router/constant";
import ShopMenu from "@/components/SideMenus/ShopMenu";
import { useMemo } from "react";

const MobileMyShopWrapper = () => {
  const location = useLocation();
  const memoDashboardRoutesArray = useMemo(() => dashboardRoutesArray(), []);
  const currentUrlObj = memoDashboardRoutesArray.find((i) => i.url === location.pathname);

  const mainMenu = <ShopMenu />;

  const subMenus = (
    <NavigationLayout
      menu={mainMenu}
      mobileBackNavigation={DashboardRoutes.myShop.root.url}
      mobileTitle={currentUrlObj?.meta?.translation || ""}
    >
      <Outlet />
    </NavigationLayout>
  );

  return location.pathname === DashboardRoutes.myShop.root.url ? mainMenu : subMenus;
};

const DesktopMyShopWrapper = () => (
  <NavigationLayout menu={<ShopMenu />}>
    <Outlet />
  </NavigationLayout>
);

const MyShopRoot = () => <DetectMobileView mobile={<MobileMyShopWrapper />} desktop={<DesktopMyShopWrapper />} />;

export default MyShopRoot;
